var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"services"},_vm._l((_vm.services),function(service,i){return _c('Service',{key:service._id,attrs:{"service":service,"serviceIndex":i,"instanceIndex":_vm.instanceIndex,"instanceUrl":_vm.instanceUrl}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }